import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DocumentClient, Documents, DocumentTypeClient, DocumentTypes, NServices, ServiceClient} from "src/app/web-api-client";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { DocumentCreationComponent } from "./document-creation/document-creation.component";
import { forkJoin } from "rxjs";
import { SigningType } from "../../../models/signing-Type.enum";
import { DocumentTypeLink } from "../../../models/documentTypeLink.enum";
import { DocumentEditComponent } from "./documents-edit/documents-edit.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class DocumentComponent implements OnInit {

  public isLoaded: boolean = false;
  public selectedService: Documents;
  public services: Documents[];
  private dTypes: DocumentTypes[];

  public searchQuery: string = '';
  public filteredServices: Documents[] = [];


  constructor(private readonly changeDetectionRef:ChangeDetectorRef, private readonly modalService: NgbModal,public client:DocumentClient,public documentTypeClient:DocumentTypeClient){

  }

  ngOnInit(): void {

    this.LoadData();

    //this.client.getList().subscribe((allDocs:Documents[])=>{
    //  this.services = allDocs;
    //  this.isLoaded = true;
    //  this.changeDetectionRef.detectChanges();
    //});

  }

  private LoadData() {
    this.isLoaded = false;
        forkJoin([this.client.getList(), this.documentTypeClient.getList()])
            .subscribe(([documents, documentTypes]) => {

              this.services = documents;
              this.filteredServices = documents;
                this.dTypes = documentTypes;

                this.isLoaded = true;
                this.changeDetectionRef.detectChanges();

            });
    }

  public getDocTypeName(docTypeId: number): string {
    return this.dTypes.find(d => d.isActive ==true && d.idDocumentType == docTypeId)?.title;
  }

  public getSignedTypeName(signedType: SigningType): string {
    switch(signedType) {
      case SigningType.NoSigning:
        return "Не Изисква Подпис";
      case SigningType.SignRequired:
        return "Изисква Подпис";
      default:
        return "Не е избран";
    }
  }

 public onSelected(service:Documents){
   if (this.isSelected(service)){
    this.selectedService = null;
  }
  else{

     this.selectedService = service;
  }
 }

  public isSelected(service: Documents):boolean{
   return this.selectedService == service;
 }

public onCreation():void{
  let modalRef =this.modalService.open(DocumentCreationComponent, {});

  modalRef.componentInstance.onClose.subscribe(r => {

    this.LoadData();

  });

}


public onDelete(): void { 


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(DocumentEditComponent);
    modalRef.componentInstance.editObject = this.selectedService;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.LoadData();

    });
    }


  public getDocTypeLink(linkType:number) {
        switch(linkType) {
          case DocumentTypeLink.Service:
            return "Услуга";
          case DocumentTypeLink.Agent:
            return "Доставчик";
          case DocumentTypeLink.ServiceProvider:
            return "Доставчик на услуги";
    }

    return "";

  }

  public GetBoolean(val: boolean): string {

    return val ? 'Да' : 'Не';
    
  }

  filterServices() {
    if (this.searchQuery) {
      this.filteredServices = this.services.filter(service =>
        service.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.description.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        this.getDocTypeName(service.idDocumentType).toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        (service.isGlobal ? 'Да' : 'Не').toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        this.getSignedTypeName(service.signedType).toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        this.getDocTypeLink(service.documentTypeLink).toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredServices = this.services;
    }
  }
}
